export enum RepliersListingPropertyType {
  // TREB
  'Detached' = 'Detached', // Detached
  'CondoApartment' = 'Condo Apt', // Condo Apartment
  'Office' = 'Office', // Not shown (commercial)
  'CommercialRetail' = 'Commercial/Retail', // Not shown (commercial)
  'FreeholdTownhouse' = 'Att/Row/Twnhouse', // Freehold Townhouse
  'Industrial' = 'Industrial', // Not shown (commercial)
  'SaleOfBusiness' = 'Sale Of Business', // Not shown (commercial)
  'SemiDetached' = 'Semi-Detached', // Semi-Detached
  'VacantLand' = 'Vacant Land', // Land
  'CondoTownhouse' = 'Condo Townhouse', // Condo Townhouse
  'Land' = 'Land', // Land
  'Investment' = 'Investment', // Other
  'CommercialElementCondo' = 'Comm Element Condo', // Included in Condo Apartment - often agents picking the wrong item on upload
  'Multiplex' = 'Multiplex', // Multiplex
  'Farm' = 'Farm', // Land
  'StoreWithAptOffice' = 'Store W/Apt/Office', // Multiplex
  'Duplex' = 'Duplex', // Multiplex
  'LowerLevel' = 'Lower Level', // Other & Multiplex
  'Other' = 'Other', // Other
  'Triplex' = 'Triplex', // Multiplex
  'ParkingSpace' = 'Parking Space', // Other
  'UpperLevel' = 'Upper Level', // Other & Multiplex
  'RuralResidential' = 'Rural Resid', // Detached
  'Cottage' = 'Cottage', // Detached
  'StoreWithAptOffc' = 'Store W/Apt/Offc', // Multiplex
  'Link' = 'Link', // Link
  'MobileTrailer' = 'Mobile/Trailer', // Other
  'CoopApt' = 'Co-Op Apt', // Condo Apartment
  'Fourplex' = 'Fourplex', // Multiplex
  'Locker' = 'Locker', // Other
  'CoOwnershipApt' = 'Co-Ownership Apt', // Condo Apartment
  'DetachedCondo' = 'Det Condo', // Detached
  'SemiDetachedCondo' = 'Semi-Det Condo', // Semi-Detached
  'Room' = 'Room', // Other
  'TimeShare' = 'Time Share', // Other
  'LeaseholdCondo' = 'Leasehold Condo', // Condo Apartment
  'VacantLandCondo' = 'Vacant Land Condo', // Land

  // ITSO Extras
  'SingleFamilyResidence' = 'Single Family Residence', // Detached
  'BuildingAndLand' = 'Building and Land', // Not shown (commercial)
  'Commercial' = 'Commercial', // Not shown (commercial)
  'Retail' = 'Retail', // Not shown (commercial)
  'DuplexUpDown' = 'Duplex Up/Down', // Multiplex
  'DuplexSideSide' = 'Duplex Side/Side', // Multiplex
  'Agriculture' = 'Agriculture', // Land
  'AgriculturalNoRes' = 'Agricultural No Res', // Not shown (commercial)
  'MobileHome' = 'Mobile Home', // Other
  'MixedUse' = 'Mixed Use', // Other
  'Mixed' = 'Mixed', // Other
  'Multi3Unit' = 'Multi-3 Unit', // Multiplex
  'Multi4Unit' = 'Multi-4 Unit', // Multiplex
  'Multi5Unit' = 'Multi-5 Unit', // Multiplex
  'Multi6To9Unit' = 'Multi-6-9 Unit', // Multiplex
  'SingleFamily' = 'Single Family', // Detached
  'MultiFamily' = 'Multi Family', // Multiplex
  'PartOfBuilding' = 'Part of Building', // Not shown (commercial)
  'BuildingOnly' = 'Building Only', // Not shown (commercial)
  'ModularHome' = 'Modular Home', // Other
  'RoomingHouse' = 'Rooming House', // Other
  'Apartment' = 'Apartment', // Condo Apartment
  'DeededParking' = 'Deeded Parking', // Other
}

export const PROPERTY_TYPE_DISPLAY_MAPPING = {
  // TREB
  [RepliersListingPropertyType.Detached]: 'Detached',
  [RepliersListingPropertyType.CondoApartment]: 'Condo Apartment',
  [RepliersListingPropertyType.Office]: 'Office', // Not shown (commercial)
  [RepliersListingPropertyType.CommercialRetail]: 'Commercial/Retail', // Not shown (commercial)
  [RepliersListingPropertyType.FreeholdTownhouse]: 'Freehold Townhouse',
  [RepliersListingPropertyType.Industrial]: 'Industrial', // Not shown (commercial)
  [RepliersListingPropertyType.SaleOfBusiness]: 'Sale Of Business', // Not shown (commercial)
  [RepliersListingPropertyType.SemiDetached]: 'Semi-Detached',
  [RepliersListingPropertyType.VacantLand]: 'Vacant Land',
  [RepliersListingPropertyType.CondoTownhouse]: 'Condo Townhouse',
  [RepliersListingPropertyType.Land]: 'Land',
  [RepliersListingPropertyType.Investment]: 'Investment',
  [RepliersListingPropertyType.CommercialElementCondo]: 'Common Element Condo',
  [RepliersListingPropertyType.Multiplex]: 'Multiplex',
  [RepliersListingPropertyType.Farm]: 'Farm',
  [RepliersListingPropertyType.StoreWithAptOffice]:
    'Store With Apartment/Office',
  [RepliersListingPropertyType.Duplex]: 'Duplex',
  [RepliersListingPropertyType.LowerLevel]: 'Lower Level',
  [RepliersListingPropertyType.Other]: 'Other',
  [RepliersListingPropertyType.Triplex]: 'Triplex',
  [RepliersListingPropertyType.ParkingSpace]: 'Parking Space',
  [RepliersListingPropertyType.UpperLevel]: 'Upper Level',
  [RepliersListingPropertyType.RuralResidential]: 'Rural Residential',
  [RepliersListingPropertyType.Cottage]: 'Cottage',
  [RepliersListingPropertyType.StoreWithAptOffc]: 'Store With Apartment/Office',
  [RepliersListingPropertyType.Link]: 'Link',
  [RepliersListingPropertyType.MobileTrailer]: 'Mobile/Trailer',
  [RepliersListingPropertyType.CoopApt]: 'Co-Op Apartment',
  [RepliersListingPropertyType.Fourplex]: 'Fourplex',
  [RepliersListingPropertyType.Locker]: 'Locker',
  [RepliersListingPropertyType.CoOwnershipApt]: 'Co-Ownership Apartment',
  [RepliersListingPropertyType.DetachedCondo]: 'Detached Condo',
  [RepliersListingPropertyType.SemiDetachedCondo]: 'Semi-Detached Condo',
  [RepliersListingPropertyType.Room]: 'Room',
  [RepliersListingPropertyType.TimeShare]: 'Time Share',
  [RepliersListingPropertyType.LeaseholdCondo]: 'Leasehold Condo',
  [RepliersListingPropertyType.VacantLandCondo]: 'Vacant Land Condo',

  // ITSO Extras
  [RepliersListingPropertyType.SingleFamilyResidence]:
    'Single Family Residence',
  [RepliersListingPropertyType.BuildingAndLand]: 'Building and Land', // Not shown (commercial)
  [RepliersListingPropertyType.Commercial]: 'Commercial', // Not shown (commercial)
  [RepliersListingPropertyType.Retail]: 'Retail', // Not shown (commercial)
  [RepliersListingPropertyType.DuplexUpDown]: 'Duplex Up/Down',
  [RepliersListingPropertyType.DuplexSideSide]: 'Duplex Side/Side',
  [RepliersListingPropertyType.Agriculture]: 'Agriculture',
  [RepliersListingPropertyType.AgriculturalNoRes]: 'Agricultural No Res', // Not shown (commercial)
  [RepliersListingPropertyType.MobileHome]: 'Mobile Home',
  [RepliersListingPropertyType.MixedUse]: 'Mixed Use',
  [RepliersListingPropertyType.Mixed]: 'Mixed',
  [RepliersListingPropertyType.Multi3Unit]: 'Multi-3 Unit',
  [RepliersListingPropertyType.Multi4Unit]: 'Multi-4 Unit',
  [RepliersListingPropertyType.Multi5Unit]: 'Multi-5 Unit',
  [RepliersListingPropertyType.Multi6To9Unit]: 'Multi-6-9 Unit',
  [RepliersListingPropertyType.SingleFamily]: 'Single Family',
  [RepliersListingPropertyType.MultiFamily]: 'Multi Family',
  [RepliersListingPropertyType.PartOfBuilding]: 'Part of Building', // Not shown (commercial)
  [RepliersListingPropertyType.BuildingOnly]: 'Building Only', // Not shown (commercial)
  [RepliersListingPropertyType.ModularHome]: 'Modular Home',
  [RepliersListingPropertyType.RoomingHouse]: 'Rooming House',
  [RepliersListingPropertyType.Apartment]: 'Apartment',
  [RepliersListingPropertyType.DeededParking]: 'Deeded Parking',
};
